import { jsx as u, jsxs as k } from "react/jsx-runtime";
import "@u-elements/u-details";
import p from "clsx";
import { forwardRef as f, useState as w, useRef as x, useImperativeHandle as R, useEffect as S } from "react";
import { Chevron as q } from "../chevron/chevron.js";
import { useTracking as A, getText as C, animateHidden as H } from "../utils.js";
import n from "./expandable.module.css.js";
const N = f(
  function({
    className: o,
    variant: c = "blue-yellow",
    defaultOpen: a = !1,
    onChange: l,
    open: b,
    tracking: v = !0,
    ...y
  }, E) {
    const [$, O] = w(a), t = b ?? $, d = x(t), i = x(null), T = c.replace(/^(line-)?([^-]+)$/, "$1$2-white"), g = A(v);
    R(E, () => i.current), S(() => {
      var s;
      if ((s = i.current) == null || s.toggleAttribute("open", t), d.current === t)
        return;
      const e = i.current, r = e == null ? void 0 : e.querySelector(`.${n.content}`);
      d.current = t, g({
        eventCategory: "expandable",
        eventAction: t ? "open" : "close",
        eventLabel: C(e == null ? void 0 : e.querySelector(`.${n.title}`))
      }), e && r && (e.open = !0) && H(r, !t).then(() => e.open = t);
    });
    const j = (e) => {
      var r, s;
      (s = (r = e.target) == null ? void 0 : r.closest) != null && s.call(r, `.${n.title}`) && (O(!t), l == null || l(!t));
    };
    return /* @__PURE__ */ u(
      "u-details",
      {
        ...y,
        class: p(n.expandable, n[T], o),
        onClick: j,
        open: t ? "" : void 0,
        ref: i
      }
    );
  }
), G = Object.assign(N, {
  Title: f(function({ children: o, className: c, ...a }, l) {
    return /* @__PURE__ */ k("u-summary", { ...a, class: p(n.title, c), ref: l, children: [
      o,
      /* @__PURE__ */ u(q, { className: n.chevron })
    ] });
  }),
  Content: f(
    function({ className: o, ...c }, a) {
      return /* @__PURE__ */ u("div", { ...c, className: p(n.content, o), ref: a });
    }
  )
});
export {
  G as Expandable
};
//# sourceMappingURL=expandable.js.map
